import React from 'react';

import {
  ScrollToTopOnMount,
  Body,
  ExtendedFlex,
  Heading,
} from '../coreui';

const linkStyle = {
  color: '#176DB6',
  textDecoration: 'none',
};
const italicized = {
  fontStyle: 'italic',
  fontWeight: 'bold',
};
const boldStyle = {
  fontWeight: 'bold',
};


export const Privacy = () => {
  return (
    <ExtendedFlex
      bg="#FFFFFF"
      flexDirection="column"
      justify="center"
      align="left"
      px="10%"
      py="5%"
      w={1}
    >
      <ScrollToTopOnMount />
      <Body type="B3">
        <Heading type="H6">Privacy Policy</Heading>
        <br /><br />
        Updated June 8, 2018
        <br /><br />
        The website <Body type="B3" style={italicized} >{'("Site")'}</Body> for Realty Mogul, Co. <Body type="B3" style={italicized} >{'("RealtyMogul," "we," or "us")'}</Body>
        , was created to provide information about our company, including our investment services,
        lending services and joint venture opportunities (together with the Site, the
        <Body type="B3" style={italicized} >{' "Services"'}</Body>). We value the privacy of our Service visitors (<Body type="B3" style={italicized} >{'"you," "your," or "user"'}</Body>),
        and in order to protect your personal information, we have implemented the following
        Privacy Policy with provisions that apply to the collection of data by RealtyMogul,
        its subsidiaries, and its affiliates. If you have questions or concerns regarding this
        statement, you should first contact us at
        <a style={linkStyle} href="mailto:info@realtymogul.com"> info@realtymogul.com</a>.
        <br /><br />
        Our Privacy Policy discloses the type and nature of information we collect and how
        we use it, as well as the choices you can make about the way your information is collected
        and used. We also explain how any requests for personal or personally identifiable
        information will be used. Finally, we present our security policy, which outlines
        how your personal information is protected.
        <br /><br />
        <Body style={boldStyle} type="B3">Information We Collect</Body>
        <br /><br />
        RealtyMogul collects personal and financial information from you when you visit the Site.
        The majority of information is collected during the registration and/or
        application process and, while some items are optional, most are required
        for legal or security purposes. You may choose to provide additional information during
        subsequent visits to the Site, but keep in mind that some of this information will
        be required if you wish to partake in the Services.
        <br /><br />
          In general, the type of information we collect includes, but is not limited to:
        <br /><br />
        <ul>
          <li>Personal data required to verify your identity;</li>
          <li>Personal and financial data necessary to assess your eligibility to utilize the
            Services on the RealtyMogul platform; and</li>
          <li>on-identifiable and aggregated personal data pertaining to your Site visits that
            help us maintain the appropriate features, functionality and user experience</li>
        </ul>
        <br />
        <Body style={boldStyle} type="B3">Personal Data</Body>
        <br /><br />
        Investor registration and lending applications will require you to provide
        basic personal data. Such information typically includes your name, email address,
        home address and phone number, date of birth, social security number and/or tax
        identification number, employer and job title. RealtyMogul uses this data to: (i)
        enable you to log in to the Site; (ii) establish your ability to view offering
        materials and to make investments through the Site (for U.S. residents, such ability
        is restricted to {'"accredited investors"'} with a certain level of annual income or net worth);
        (iii) determine your credibility to partake in lending opportunities; (iv) verify that
        you are at least 18 years of age; (v) guard against potential fraud; (vi) contact you if
        there is a problem with your account; and (vii) maintain regular communications with you
        as may be necessary to inform you of upcoming investment opportunities and other company
        updates, including SMS communications to users who have opted-in to RealtyMogul’s SMS
        Communications program.
        <br /><br />
        RealtyMogul will also gather the names and email addresses of users who contact us through
        the Site with questions about our company or lending platform. We collect this information
        for the sole purpose of responding to such inquiries and do not store the contact
        information unless requested to do so, as in the case of job applicants who submit resumes.
        <br /><br />
        <Body style={boldStyle} type="B3">Financial Data (for Investors)</Body>
        <br /><br />
        When you subscribe to make an investment in one of our offerings on the platform, you will
        again be asked for your personal data. You will also be required to provide financial data,
        such as your bank routing number and bank account number, to enable us or our broker-dealer
        partners to utilize your bank account to originate funds transfers and make subsequent
        investment disbursements to you.
        <br /><br />
        <Body style={boldStyle} type="B3">Financial Data (for Borrowers)</Body>
        <br /><br />
        You will be asked to provide and disclose financial data when filling out an application to partake in lending services. Such information may be shared with third parties. See <Body style={italicized} type="B3">{'"How and When Your Information Is Shared With Other Parties"'}</Body> for more details.
        <br /><br />
        <Body type="B3" style={italicized} >Non-Identifiable Data and Aggregated
        Personal Data</Body>
        <br /><br />
        Regardless of whether you register for an account or submit an application, RealtyMogul may
        send one or more {'"cookies"'} to your computer. Cookies are small text files placed on your
        web browser when you visit our Site that store information on your computer, such as
        your Site preferences. We use cookies when you sign in to keep track of your
        personal session, including some account identifiers to ensure that you are the
        only person making changes to your account. We also use cookies to track your activity
        on the Site as a unique person. For security purposes, all of this information is stored
        in encrypted form. No personal information about you is stored.
        <br /><br />
        You can set your web browser to inform you when cookies are set, or to prevent cookies
        from being set altogether. Please note, however, that if you decline to use cookies,
        you may experience reduced functionality and slower site response times.
        In some instances, declining to use our authentication-related cookies may prevent you
        from using the website entirely.
        <br /><br />
        RealtyMogul (or our service providers, such as Google Analytics) may also collect web
        surfing data related to your use of the Site. Such information may include: your Internet
        Protocol (IP) address, browser type, and internet service provider (ISP); your
        operating system; which of our web pages you access and how frequently you access them;
        referral or exit pages; click stream data; and the dates and times that you visit the Site.
        This data may be collected using cookies, web beacons, page tags or similar tools.
        As with cookies, the web surfing information is anonymous, {'"click stream"'} transactional
        data that is not associated with any users as individuals.
        <br /><br />
        Web surfing data and similar information may be aggregated for administrative purposes.
        RealtyMogul may, for example, use this aggregated information in
        the administration of the Site to improve its usability and to evaluate the success
        of particular marketing and advertising campaigns, search engine optimization
        strategies, and other marketing activities. We also use it to help optimize the Site
        based on the needs of our users.
        <br /><br />
        <Body style={boldStyle} type="B3">How and When Your Information Is Shared With Other
        Parties</Body>
        <br /><br />
        RealtyMogul does not sell or rent personal information about its users for
        marketing purposes. We do, however, work with a number of trusted partners
        who perform vital functions as part of our operations.
        <br /><br />
        <Body type="B3" style={italicized} >Sharing of Investor Information</Body>
        <br /><br />
        <a style={linkStyle} href="https://www.northcapital.com/" rel="noopener noreferrer" target="_blank">North Capital Private Securities Corp. </a>({'"North Capital" or “NCPS”'}), a Delaware corporation, is a securities broker-dealer registered with the <a style={linkStyle} href="https://www.sec.gov" rel="noopener noreferrer" target="_blank">U.S. Securities and Exchange Commission</a> and a member of <a style={linkStyle} href="https://www.finra.org" rel="noopener noreferrer" target="_blank">FINRA</a> and <a style={linkStyle} href="http://www.sipc.org" rel="noopener noreferrer" target="_blank">SIPC</a>.
        North Capital is a provider of execution and other brokerage services related to our equity securities transactions, and certain individual personnel of RealtyMogul are registered representatives of North Capital. North Capital is headquartered at 623 E Fort Union Boulevard, Suite 101, Salt Lake City, UT 84047. Tel:(415) 315-9916 (<a style={linkStyle} href="https://www.northcapital.com/" rel="noopener noreferrer" target="_blank">https://www.northcapital.com/</a>).
        <br /><br />
        Because North Capital will perform services related to the offering, transaction, and settlement of our equity securities transactions, your personal information will be shared with North Capital and will be subject to its <a href="https://www.northcapital.com/north-capital-private-securities-corporation-privacy-statement/" style={linkStyle} target="_blank" rel="noopener noreferrer">Privacy Policy </a>
        and <a rel="noopener noreferrer" href="https://www.sec.gov/rules/final/34-42974.htm" target="_blank" style={linkStyle} >Regulation S-P</a>. In addition to sharing your information with North Capital, we will also notify the party or parties offering (or issuing) the investment of your interest, and may notify other users in the event that you have chosen to share such information. North Capital also utilizes <a style={linkStyle} href="https://www.kingdomtrust.com/" target="_blank" rel="noopener noreferrer">Kingdom Trust Company</a>, a South Dakota Trust company,
        for escrow services with respect to such equity transactions. Since we do
        not have direct control over the policies and practices of either North Capital
        or Kingdom Trust, we are not responsible for their privacy policies or practices or
        contents of their websites.
        <br /><br />
        <Body type="B3" style={italicized} >Sharing of Borrower Information</Body>
        <br /><br />
        If you are a potential borrower, then as part of the loan application process,
        we may verify information contained in the loan application and in other
        documents required in connection with the loan, either before the loan is
        closed or as part of our quality control program.  Your information may also
        be shared with any investor to whom we may sell your mortgage; any investor
        to whom we may issue, sell, or resell Borrower Payment Dependent Notes
        ({'"Notes"'}) associated with your loan; and to any loan guaranty insurer.
        Such data may include, but is not limited to, employment history and
        income; bank, money market, and similar account balances; credit score
        and credit history; copies of income tax returns; and consumer report information.
        Such data may be provided to users of the platform to aid in their decision
        to commit funds.
        <br /><br />
        <Body type="B3" style={italicized} >Additional Sharing of Both Investor &
        Borrower Information</Body>
        <br /><br />
        RealtyMogul also works with (among others) providers of hosting services for
        the Site, electronic signature providers, and electronic payment service providers.
        We may engage third parties to help us carry out certain other internal functions
        such as account processing, client services, or other data collection relevant to
        our business. Examples of third parties might include those that perform data
        processing, reporting, tax documentation, custody or escrow services. Information
        is shared with these third parties only to the extent necessary for us to process
        the transactions you initiate or perform other specific services, like collections.
        Our partners are legally required to keep your information private and secure.
        <br /><br />
        We may share your information with law enforcement or other government agencies as
        required by law or for the purposes of limiting fraud. We reserve the right to disclose
        your personally identifiable information when we believe that disclosure is necessary
        to protect our rights or to comply with a judicial proceeding, court order or legal process.
        We further reserve the right to disclose any of your personal information that we believe,
        in good faith, appropriate or necessary to take precautions against liability,
        to investigate and defend against any third-party claims or allegations, to assist
        government enforcement agencies, to protect the security or integrity of the Site
        or our services, or to protect the rights, property or personal safety of RealtyMogul,
        its users, issuers, or others.
        <br /><br />
        <Body style={boldStyle} type="B3">Notifications and Communications from Our Site</Body>
        <br /><br />
        RealtyMogul will send you email notifications from time to time. Some notifications
        are required elements of your transactions on our platform, such as confirmations of
        particular actions you have taken. These mandatory notices are sent typically to notify
        you of a change in status. For example, you will receive a notice when you are confirmed
        as an investor.
        <br /><br />
        We also send out notices that are required for legal or security purposes.
        For example, certain notifications are sent for your own protection to ensure that
        another person cannot make a change to your account without your knowledge. In other
        cases, these notifications involve changes to various legal agreements or Site policies.
        Generally, you may not opt out of such service-related emails.
        <br /><br />
        When you register as an investor, you will receive emails that confirm specific actions
        you requested. These will include emails to which you must respond to complete your
        registration and notifications confirming your registration. Thereafter, you will receive
        emails when a new investment opportunity is offered, as well as updates concerning the
        progress of the funding of such offering and/or other relevant information. If you make an
        investment through the Site, RealtyMogul or North Capital will also send you
        confirmations of the investment as well as occasional updates as to the status of that
        investment and the timing of distributions relating to that investment.
        <br /><br />
        When you register as an investor and opt-in to RealtyMogul’s SMS Communications program,
        you are consenting to receive text messages sent by an automatic telephone dialing system
        and acknowledge that data usage charges may apply by your cell phone company.
        You may receive text messages regarding system notifications, investment opportunity
        updates, and special offers and promotions, and can manage your opt-in status in
        your user profile.
        <br /><br />
        We may also send you responses to emails you send us, if appropriate. From time to time,
        we will also send user surveys, requests for user feedback regarding user experience and
        Site operations, or marketing offers from us or from us on behalf of our marketing partners.
        Completing these surveys, answering requests for feedback, or accepting
        any offer is strictly voluntary. If you do not wish to receive these surveys,
        user feedback emails, and/or marketing offers, please opt out in any offer email you
        receive from us.
        <br /><br />
        <Body style={boldStyle} type="B3">Where You Can View and Correct Your Information</Body>
        <br /><br />
        We urge you to review your information regularly to ensure that it is correct and complete.
        If you believe that any of your information is incorrect, or if you have any questions
        regarding this Privacy Policy, please contact us at
        <a style={linkStyle} href="mailto:info@realtymogul.com"> info@realtymogul.com</a>.
        <br /><br />
        <Body style={boldStyle} type="B3">Links to Other Sites</Body>
        <br /><br />
        If you follow any links that direct you away from the Site, this privacy policy will
        not apply to your activity on the other websites you visit. We do not control the privacy
        policies or the privacy practices of any third parties.
        <br /><br />
        <Body style={boldStyle} type="B3">International Users</Body>
        <br /><br />
        The Site may be accessed by users located outside the United States. If you choose
        to use the Service from the European Union or other regions of the world with laws
        governing data collection and use that may differ from U.S. law, then please note
        that you are transferring your personal information outside of those regions to the
        United States, and that by providing your personal information on or through the
        Site then you consent to that transfer.
        <br /><br />
        <Body style={boldStyle} type="B3">Security Policy</Body>
        <br /><br />
        <Body style={italicized} type="B3">Access Limitations</Body>
        <br /><br />
        We limit access to the personal information we have about you to those
        employees who have a legitimate business need to access such information.
        In keeping with industry standards and practices, we maintain appropriate physical,
        electronic and procedural safeguards and controls to protect your information.
        The Site is built upon a secure infrastructure with multiple layers of protection,
        and we use industry-standard encryption technologies to safeguard your information.
        <br /> <br />
        Users are required to identify and authenticate themselves prior to accessing sensitive
        portions of the Site. Generally, identification and authentication take place through
        the use of your username and a password and/or while logging in with one of our technical
        support staff.
        <br /><br />
        <Body type="B3" style={italicized} >Notifications of Security Systems Breach</Body>
        <br /><br />
        If we learn of a security systems breach, then we may attempt to notify you electronically
        so that you can take appropriate protective steps. We may also post a notice on or through
        the Site in the event of a security breach. Depending on where you live, you may have a
        legal right to receive notice of a security breach in writing.
        <br /><br />
        <Body type="B3" style={italicized} >Take Precautionary Measures</Body>
        <br /><br />
        You can take several precautions to protect the security of your computer and
        personal information. For instance, you can use a well-chosen password and restrict
        access to your email account. You can also install and regularly update antivirus
        and firewall software to protect your computer from external attacks by malicious users.
        When you are finished with a session on the Site, be sure that you log out and
        close the browser window.
        <br /><br />
        You should also be aware of fraudulent attempts to gain access to your account information through {'"phishing,"'} whereby scammers try to bring unsuspecting people to a website by using a genuine-looking email purporting to be from a legitimate company. Sometimes, either in the email itself or on this fake site, scammers will ask for login information to gain access to people&apos;s accounts and withdraw their money.
        <br /><br />
        RealtyMogul will never send you an email asking you for your login information. In general, you can protect yourself against phishing by never providing personal or login information via a link contained in an email; instead, go the website directly. You might also make it a habit to check the URL of a website to be sure that it begins with the correct domain. In the case of RealtyMogul, you should always ensure the URL begins with <a style={linkStyle} href="https://realtymogul.com">https://realtymogul.com</a> or <a style={linkStyle} href="https://www.realtymogul.com">https://www.realtymogul.com</a>.
      </Body>
    </ExtendedFlex>
  );
};
export default Privacy;
